<template lang="pug">
  .widget-donut
    AppChartDonutDouble(
      :circles="[{ value: remoteValue, tooltip: remoteTooltip }, { value: officeValue, tooltip: officeTooltip }]"
      :thickness="thickness"
      :size="size"
    )
</template>

<script>
export default {
  name: 'InsightsUtilizationWidgetDoubleDonut',
  components: {
    AppChartDonutDouble: () => import('~/components/AppChartDonutDouble.vue'),
  },
  props: {
    remoteValue: { type: Number, required: true },
    officeValue: { type: Number, required: true },
    remoteTooltip: { type: String, default: '' },
    officeTooltip: { type: String, default: '' },
    thickness: { type: Number, default: 15 },
    size: { type: Number, default: 132 },
  },
};
</script>
